import { render, staticRenderFns } from "./SharingModule.vue?vue&type=template&id=1da01202&scoped=true"
import script from "./SharingModule.vue?vue&type=script&lang=js"
export * from "./SharingModule.vue?vue&type=script&lang=js"
import style0 from "./SharingModule.vue?vue&type=style&index=0&id=1da01202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da01202",
  null
  
)

export default component.exports